var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("label", { staticClass: "checkbox" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _setup.check_calc,
          expression: "check_calc",
        },
      ],
      staticClass: "checkbox__input",
      attrs: { type: "checkbox" },
      domProps: {
        checked: Array.isArray(_setup.check_calc)
          ? _vm._i(_setup.check_calc, null) > -1
          : _setup.check_calc,
      },
      on: {
        change: function ($event) {
          var $$a = _setup.check_calc,
            $$el = $event.target,
            $$c = $$el.checked ? true : false
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v)
            if ($$el.checked) {
              $$i < 0 && (_setup.check_calc = $$a.concat([$$v]))
            } else {
              $$i > -1 &&
                (_setup.check_calc = $$a
                  .slice(0, $$i)
                  .concat($$a.slice($$i + 1)))
            }
          } else {
            _setup.check_calc = $$c
          }
        },
      },
    }),
    _vm._v(" "),
    _c(
      "svg",
      {
        staticClass: "checkbox__check",
        attrs: { width: "24", height: "24", viewBox: "0 0 24 24" },
      },
      [_c("polyline", { attrs: { points: "20 6 9 17 4 12" } })]
    ),
    _vm._v(" "),
    _c(
      "span",
      { staticClass: "checkbox__text" },
      [
        _vm._t("default", function () {
          return [
            _vm._v("\n\t\t\t" + _vm._s(_setup.props.item.name) + "\n\t\t"),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }